/**
 * Formato de fecha para MOSTRAR: DD/MM/AAAA.
 *
 * En la base las fechas se guardan como texto "AAAA-MM-DD" y así se comparan,
 * se filtran y se mandan al servidor. Este helper es SÓLO para pintarlas en
 * pantalla, PDFs y Excels: nunca debe usarse para el `value` de un
 * <Input type="date"> ni para armar filtros, porque ahí el formato ISO es el
 * que entiende el navegador y el que ordena correctamente.
 *
 *   fDMA("2026-08-31")            → "31/08/2026"
 *   fDMA("2026-08-31T14:22:00Z")  → "31/08/2026"
 *   fDMA("")                      → ""
 */
export const fDMA = (valor) => {
  if (!valor) return "";
  const texto = String(valor).slice(0, 10);
  const partes = /^(\d{4})-(\d{2})-(\d{2})$/.exec(texto);
  // Si no viene en ISO se devuelve tal cual: mejor mostrar el dato original
  // que inventar un formato sobre algo que no reconocemos.
  return partes ? `${partes[3]}/${partes[2]}/${partes[1]}` : String(valor);
};

export default fDMA;
